import React, { useState } from 'react';
import { Typography } from 'antd';
import DivisionalItemsCard from './DivisionalItemCard';

const { Title } = Typography;

interface SelectedDivision {
  division: {
    id: string;
    name: string;
    address: string;
    code: string;
    description: string;
    status: string;
    type: string;
    lab_request_types: any;
  };
  labRequestDepartmentId?: number | null;
  alreadyAddedTests: any[];
  status_label: string;
  reportData: any[];
}

interface TestsComponentProps {
  selectedDivisions: SelectedDivision[];
  status: string | null;
  lab_id: number | null;
  tr_type: string | null;
  status_step: string;
  lab_type: string;
}

const TestsComponent: React.FC<TestsComponentProps> = ({
  selectedDivisions,
  status,
  lab_id,
  tr_type,
  status_step,
  lab_type,
}) => {
  const [divisionsTestsData, setDivisionsTestsData] = useState<Record<string, any[]>>(() => {
    const initialData: Record<string, any[]> = {};
    selectedDivisions.forEach((division) => {
      initialData[division.division.id] = division.alreadyAddedTests;
    });
    return initialData;
  });

  const handleTestsUpdated = (divisionId: string, updatedTests: any[]) => {
    setDivisionsTestsData((prev) => ({
      ...prev,
      [divisionId]: updatedTests,
    }));
  };

  console.log('passed step:', status_step);
  return (
    <div>
      {selectedDivisions.length === 0 ? (
        <p>No divisions selected.</p>
      ) : (
        selectedDivisions.map(({ division, labRequestDepartmentId, alreadyAddedTests }) => (
          <DivisionalItemsCard
            key={division.id}
            divisionId={division.id}
            divisionName={division.name}
            divisionCode={division.code}
            deptId={labRequestDepartmentId}
            status={status}
            lab_id={lab_id}
            context={tr_type}
            alreadyAddedTests={divisionsTestsData[division.id] || alreadyAddedTests}
            onTestsUpdated={(updatedTests) => handleTestsUpdated(division.id, updatedTests)}
            status_step={status_step}
            lab_type={lab_type}
          />
        ))
      )}
    </div>
  );
};

export default TestsComponent;
